import { useEffect, useRef, useState } from "react";
import {
  Container,
  ContainerRow,
  ContainerView,
} from "../../../components/Container";
import { SZT_SOURCE, useApp } from "../../../contexts";

import {
  InfoIcon,
  InfoTooltipIcon,
  TooltipView,
  WalletAlert,
  WalletConvertInfo,
  WalletConvertInfoItem,
  WalletConvertInfoItemTitle,
  WalletConvertInfoItemValue,
  WalletDetailNotify,
  WalletDetailRow,
  WalletRow,
  WalletRowLeft,
} from "./styles";
import { Form } from "antd";
import {
  FormButton,
  FormInputNumberRaw,
  FormItemRow,
  FormSelect,
} from "../../../components/Form";
import {
  errorView,
  formatCurrency,
  getConvertFee,
  getConvertNote,
  getWallet,
  getWalletList,
  getWalletListSzt,
  getWalletMLM,
  postCheckPhoneVerify,
  ssoGetUserInfo,
  postConvert,
  roundNumber,
  transferWalletMLM,
} from "../../../services/app";
import produce from "immer";
import ModalPhoneVerify from "./modal";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { MIN_CONVERT_AMOUNT, TYPE_WALLET_DETAIL } from "../../../constants";
import { TitleWithBack } from "../../../components/Layout";
import { error, success } from "../../../Notification";
import { getCoinCodeImage } from "../../../utils/helper";
import { ModalPasswordRequired } from "../../../components/ModalPasswordRequired";

export default function WithDrawGameCurrency(props) {
  const {
    T,
    formatLocalCurrency,
    getCurrency,
    convertToBTC,
    convertToLocalCurrency,
    currencies,
    setLoading,
    isCanConvertAffiliate,
  } = useApp();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  let { type, id, code, walletId } = {
    type: searchParams.get("type"),
    code: searchParams.get("code"),
    walletId: searchParams.get("walletId"),
    ...(useParams() || {}),
  };
  const [viewType, setViewType] = useState(type);
  const [wallet, setWallet] = useState({});
  const [wallets, setWallets] = useState([]);
  const [draftValue, setDraftValue] = useState({});
  const [showSetPassword, setShowSetPassword] = useState(false);
  const [fee, setFee] = useState(0);
  const [note, setNote] = useState({});
  const [form] = Form.useForm();
  const currentRef = useRef();
  const [available, setAvailable] = useState(false);
  const [errors, setErrors] = useState([]);
  const [modal, setModal] = useState(false);
  const isOptionType = type === "option";
  if (isOptionType) {
    type = TYPE_WALLET_DETAIL.CRYPTO;
  }

  useEffect(() => {
    setViewType(type);
    loadData().then((currencyCode) => {
      form.setFieldsValue({ from: currencyCode || "" });
      setDraftValue({ from: currencyCode || "" });
    });
    let timer = setInterval(() => {
      if (!!currentRef?.current?.from && !!currentRef?.current?.to) {
        loadNote(currentRef.current.from, currentRef.current.to);
      }
    }, 5000);
    return () => {
      clearInterval(timer);
    };
  }, [type, walletId]);

  const loadData = async () => {
    setLoading(true);
    let currentWallet = "";
    const resultWallet = await Promise.all([
      getWalletList(),
      getWalletListSzt(),
      // getWalletMLM(),
    ]);
    const dataWallets = resultWallet?.[0]?.data?.data?.wallets?.rows ?? [];
    const dataSZTWalk = {
      id: resultWallet?.[1]?.data?.data?.id,
      dog_food: resultWallet?.[1]?.data?.data?.dogFood,
      possible_convert_balance:
        resultWallet?.[1]?.data?.data?.possibleConvertBalance,
      freeze_dog_food: resultWallet?.[1]?.data?.data?.freezeDogFood,
      member_id: resultWallet?.[1]?.data?.data?.memberId,
      address: resultWallet?.[1]?.data?.data?.address,
      currency_type: resultWallet?.[1]?.data?.data?.type,
      currency_code: "SZT",
      create_time: resultWallet?.[1]?.data?.data?.createTime,
      source: SZT_SOURCE.SUZU,
    };
    // const dataSZTMLM = {
    //   dog_food:
    //     resultWallet?.[2]?.data?.data?.frozenBalanceSZT +
    //     resultWallet?.[2]?.data?.data?.possibleBalanceSZT,
    //   possible_convert_balance:
    //     resultWallet?.[2]?.data?.data?.possibleBalanceSZT,
    //   freeze_dog_food: 0,
    //   currency_code: "SZT",
    //   source: SZT_SOURCE.MLM,
    // };
    currentWallet = dataSZTWalk.currency_code + "#" + SZT_SOURCE.SUZU;
    if (type === TYPE_WALLET_DETAIL.COMMISSION) {
      // setWallet(dataSZTMLM);
      // currentWallet = dataSZTMLM.currency_code + "#" + SZT_SOURCE.MLM;
    } else {
      setWallet(dataSZTWalk);
      currentWallet = dataSZTWalk.currency_code + "#" + SZT_SOURCE.SUZU; // mark differen szt between mlm with suzu
    }
    dataWallets.push(dataSZTWalk);
    // dataWallets.push(dataSZTMLM);
    setWallets(dataWallets);
    setLoading(false);
    return currentWallet;
  };

  const convertData = () => {
    return {
      wallet: {
        ...wallet,
        coin: wallet.currency_code,
        code: wallet.currency_code,
        cName: getNameByCode(wallet?.currency_code),
        coinName: T(
          `${getNameByCode(wallet?.currency_code) || ""} (${
            wallet.currency_code
          })`
        ),
        amount: wallet.dog_food,
        amountText: `${formatCurrency(wallet?.dog_food || 0)} ${
          wallet.currency_code
        }`,
        local: convertToLocalCurrency(
          wallet.dog_food,
          wallet.currency_code,
          getCurrency()
        ),
        localText: formatLocalCurrency(
          roundNumber(
            convertToLocalCurrency(
              wallet.dog_food,
              wallet.currency_code,
              getCurrency()
            ) || 0,
            2
          )
        ),
        icon: `/assets/images/otc/crypto/${
          getCoinCodeImage(wallet?.currency_code)?.toLowerCase() || "szt"
        }.svg`,
      },
      rows: wallets.map((item, index) => {
        const data = {
          ...item,
          coin: item.currency_code,
          amount: item.dog_food,
          coinName: T(
            `${getNameByCode(item?.currency_code)} (${item.currency_code})`
          ),
          btc: convertToBTC(item.dog_food, item.currency_code, getCurrency()),
          local: convertToLocalCurrency(
            item.dog_food,
            item.currency_code,
            getCurrency()
          ),
        };
        return data;
      }),
    };
  };

  const loadFee = async (amount, currencyCode) => {
    let result = await getConvertFee(amount, currencyCode);
    if (result?.status === 200) {
      setFee(result?.data?.data || 0);
    }
  };

  const loadNote = async (from, to) => {
    let result = await getConvertNote(from, to);
    if (result?.status === 200) {
      setNote(result?.data?.data || 0);
    }
  };

  const onTransactionHistory = () => {
    navigate(
      `/wallet-detail/${type}?code=${
        wallet?.currency_code || ""
      }&walletId=${walletId}`
    );
  };

  const getNameByCode = (code) => {
    return currencies.find((item) => item.code === code)?.name || "";
  };
  const checkUserHasPassword = async () => {
    try {
      let result = await ssoGetUserInfo();
      if (result?.data?.data?.has_password) {
        return true;
      }
      return false;
    }catch (err) {
      return false;
    }
    
  }
  const onConvert = async (values) => {
    const validatePassword = await checkUserHasPassword();
    if (!validatePassword) {
      setShowSetPassword(true);
      return;
    }
    const [code, source] = values?.from?.split("#") ?? [];
    if (source === SZT_SOURCE.SUZU) {
      const getValue = (code) => {
        const item = wallets.find((item) => item.currency_code === code);
        return item?.id || "";
      };
      setLoading(true);

      const resultVerify = await postCheckPhoneVerify(getValue(code));
      if (!!resultVerify?.data?.data?.isVerificationPhone) {
        setModal(true);
        setLoading(false);
        return;
      }
    }
    setLoading(true);

    const data = {
      destCurrencyCode: values.to,
      amount: values.amount,
    };
    let result = {};
    if (source === SZT_SOURCE.SUZU) {
      result = await postConvert(data);
    } else {
      result = await transferWalletMLM(data);
    }
    if (result.status === 200) {
      success(T("A conversion request has been created"));
      form.resetFields();
      setAvailable(false);
      await loadData();
      onTransactionHistory();
    } else {
      setErrors(result?.data?.error?.validates || []);
      if (!(result?.data?.error?.validates || []).length) {
        error(T(result?.data?.error?.message || "Some error happened. Please try again later."));
      }
    }
    setLoading(false);
  };
  const onSetPassword = () => {
    navigate(`/set-password`);
  }
  const getFromCurrency = () => {
    const [code, source] = draftValue?.from?.split("#") ?? [];
    const item = wallets.find(
      (item) => item.currency_code === code && item.source === source
    );
    return item
      ? {
          ...item,
          coin: item?.currency_code || code,
          amount: item.dog_food,
          amountPossible: item.possible_convert_balance || 0,
          btc: convertToBTC(item.dog_food, item.currency_code, getCurrency()),
          local: convertToLocalCurrency(
            item.dog_food,
            item.currency_code,
            getCurrency()
          ),
        }
      : {};
  };

  const value = convertData()?.wallet || {};
  const fromCurrency = getFromCurrency() || {};
  const onUpdateData = () => {
    const values = form.getFieldsValue();
    setDraftValue(values);
    const [code, source] = values?.from?.split("#") ?? [];
    if (values.from && values.amount) {
      loadFee(values.amount, code);
    }
    if (values.from && values.to) {
      currentRef.current = {
        from: code,
        to: values.to,
      };
      loadNote(code, values.to);
    } else {
      currentRef.current = {};
    }
    setAvailable(
      values.from && values.amount > MIN_CONVERT_AMOUNT && values.to
    );
  };

  const filterWalletOptions = () => {
    if (isCanConvertAffiliate) {
      return wallets.filter(
        (item) =>
          item.source === SZT_SOURCE.MLM || item.source === SZT_SOURCE.SUZU
      );
    }
    return wallets.filter((item) => item.source === SZT_SOURCE.SUZU);
  };

  if (!isCanConvertAffiliate && type === TYPE_WALLET_DETAIL.COMMISSION) {
    navigate("/");
  }

  const renderGameCurrency = () => {
    return (
      <>
        <WalletDetailRow className={"game-version"}>
          <WalletDetailNotify style={{ marginRight: 0 }}>
            <InfoIcon />
            <div
              dangerouslySetInnerHTML={{
                __html: T(
                  `convert.note.${value.coin?.toString().toLowerCase()}`
                ),
              }}
            />
          </WalletDetailNotify>

          <WalletRow style={{ width: "100%" }}>
            <WalletRowLeft>
              <Form
                layout={"vertical"}
                form={form}
                onFinish={(values) => {
                  onConvert(values);
                }}
                onValuesChange={() => {
                  onUpdateData();
                }}
              >
                <FormItemRow
                  name={"from"}
                  label={T("From Currency")}
                  initialValue={value.coin}
                  rules={[
                    {
                      required: true,
                      message: T("From Currency is required!"),
                    },
                  ]}
                >
                  <FormSelect>
                    {filterWalletOptions().map((item, index) => {
                      return (
                        <FormSelect.Option
                          key={index.toString()}
                          value={item.currency_code + "#" + item.source}
                        >
                          {T(getNameByCode(item.currency_code))} (
                          {item.currency_code + " "}
                          {T(
                            item.source === SZT_SOURCE.SUZU
                              ? "Walk-to-earn"
                              : "Affiliate"
                          )}
                          )
                        </FormSelect.Option>
                      );
                    })}
                  </FormSelect>
                </FormItemRow>
                <FormItemRow
                  {...errorView(errors, "destWalletId")}
                  name={"to"}
                  label={T("To Currency")}
                  rules={[
                    {
                      required: true,
                      message: T("To Currency is required!"),
                    },
                  ]}
                >
                  <FormSelect
                    onChange={() => {
                      setErrors(
                        produce((draft) => {
                          draft.splice(
                            draft.findIndex(
                              (item) => item.key === "destWalletId"
                            ),
                            1
                          );
                        })
                      );
                    }}
                  >
                    {currencies
                      .filter((item) => item.is_to_allow_transfer === 1)
                      .map((item, index) => {
                        return (
                          <FormSelect.Option
                            key={index.toString()}
                            value={item.code}
                          >
                            {T(item.name)} ({item.code})
                          </FormSelect.Option>
                        );
                      })}
                  </FormSelect>
                </FormItemRow>

                {draftValue?.from && draftValue?.to && note ? (
                  <ContainerRow style={{ marginBottom: 10, marginTop: 10 }}>
                    <Container style={{ flex: 1 }}>
                      <WalletDetailNotify
                        style={{ marginTop: 0, width: "100%" }}
                      >
                        <InfoIcon />
                        <div>
                          <ContainerRow style={{ alignItems: "center" }}>
                            <b>{note?.currentPair || ""}: </b>
                            <span style={{ marginLeft: 4 }}>
                              {note?.rate || ""}
                            </span>
                          </ContainerRow>
                        </div>
                      </WalletDetailNotify>
                    </Container>
                  </ContainerRow>
                ) : null}
                <FormItemRow
                  className="input-amount"
                  {...errorView(errors, "amount")}
                  name={"amount"}
                  label={T("Amount")}
                  rules={[
                    {
                      validator: (_, value) => {
                        if (!value) {
                          return Promise.reject(
                            new Error(T("Amount is required!"))
                          );
                        }
                        if (value <= MIN_CONVERT_AMOUNT) {
                          return Promise.reject(
                            new Error(
                              T(
                                "Converted amount must be higher than {amount}"
                              ).replace("{amount}", MIN_CONVERT_AMOUNT)
                            )
                          );
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <FormInputNumberRaw
                    step={0.001}
                    onChange={() => {
                      setErrors(
                        produce((draft) => {
                          draft.splice(
                            draft.findIndex((item) => item.key === "amount"),
                            1
                          );
                        })
                      );
                    }}
                    onAll={() => {
                      form.setFieldValue(
                        "amount",
                        parseFloat(fromCurrency?.amountPossible)
                      );
                      setErrors(
                        produce((draft) => {
                          draft.splice(
                            draft.findIndex((item) => item.key === "amount"),
                            1
                          );
                        })
                      );
                      onUpdateData();
                    }}
                    addonAfter={fromCurrency?.coin || ""}
                    placeholder={T(`Please enter the {coin} amount`).replace(
                      "{coin}",
                      fromCurrency?.coin || ""
                    )}
                  />
                </FormItemRow>
                {draftValue?.from &&
                draftValue?.to &&
                draftValue.amount &&
                note ? (
                  <ContainerRow style={{ marginBottom: 10, marginTop: 36 }}>
                    <Container style={{ flex: 1 }}>
                      <WalletDetailNotify
                        style={{ marginTop: 0, width: "100%" }}
                      >
                        <InfoIcon />
                        <div
                          dangerouslySetInnerHTML={{
                            __html: T("converted-text")
                              .split("{currencyCode}")
                              .join(draftValue?.to)
                              .replace(
                                "{amount}",
                                formatCurrency(
                                  draftValue.amount * note?.rate,
                                  8
                                )
                              ),
                          }}
                        />
                      </WalletDetailNotify>
                    </Container>
                  </ContainerRow>
                ) : null}

                <ContainerRow style={{ marginTop: 40, marginBottom: 16 }}>
                  <WalletConvertInfo style={{ flex: 1 }}>
                    <WalletConvertInfoItem>
                      <WalletConvertInfoItemTitle>
                        {T("Possible to convert")}
                        <TooltipView
                          color={"#EAF2FF"}
                          overlayClassName={"note-tooltip"}
                          title={T(
                            draftValue?.from?.includes(SZT_SOURCE.MLM)
                              ? "You can only convert the commission earned from most recent closed period"
                              : "You can only convert the amount earned from walking"
                          )}
                        >
                          <InfoTooltipIcon style={{ marginLeft: 9 }} />
                        </TooltipView>
                      </WalletConvertInfoItemTitle>
                      <WalletConvertInfoItemValue className={"text-aia-red"}>
                        {formatCurrency(fromCurrency?.amountPossible || 0)}{" "}
                        {fromCurrency?.coin}
                      </WalletConvertInfoItemValue>
                    </WalletConvertInfoItem>
                    <WalletConvertInfoItem>
                      <WalletConvertInfoItemTitle>
                        {T("Fee")}
                      </WalletConvertInfoItemTitle>
                      <WalletConvertInfoItemValue>
                        {fee || "0"} {fromCurrency?.coin}
                      </WalletConvertInfoItemValue>
                    </WalletConvertInfoItem>
                  </WalletConvertInfo>
                </ContainerRow>

                <ContainerRow style={{ marginBottom: 40 }}>
                  <Container style={{ flex: 1 }}>
                    <WalletAlert>
                      {T(
                        "After our team reviews and approves your request, the conversion will be executed."
                      )}
                    </WalletAlert>

                    <FormButton disabled={!available} htmlType={"submit"}>
                      {T("Request to Convert")}
                    </FormButton>
                  </Container>
                </ContainerRow>
              </Form>
            </WalletRowLeft>
          </WalletRow>
        </WalletDetailRow>
      </>
    );
  };
  return value?.code ? (
    <Container>
      <ContainerView>
        <TitleWithBack
          title={T("Conversion Request")}
          onClick={() => navigate(-1)}
        />

        {renderGameCurrency()}
      </ContainerView>

      {modal ? (
        <ModalPhoneVerify
          onClose={(value) => {
            setModal(null);
            if (value) {
              success(
                value === "success"
                  ? T("Successfully verified your phone number")
                  : ""
              );
            }
          }}
          value={modal}
        />
      ) : null}
      {showSetPassword && <ModalPasswordRequired 
        onClose={() => setShowSetPassword(false)} 
        onSubmit={() => onSetPassword()} 
      />}
    </Container>
  ) : null;
}
